import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_Persone_List_Interface, Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PersonService } from 'src/app/Service/Person/Person.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-PersonList',
  templateUrl: './PersonList.component.html',
  styleUrls: ['./PersonList.component.scss']
})
export class PersonListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  Filter_person:string="1"
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;
  modalRef_DeleteExpertCalibration: any;

  constructor(
    private Person_Service:PersonService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private ExpertCalibration_Service:ExpertCalibrationService,
    private modalService: BsModalService
  ) { }


  DataList_Persone:Array<Persone_List_Interface>=[]
  DataList_Persone_Excel:Array<any>=[]
  Data_Seleted_Delete:Persone_List_Interface=Empty_Persone_List_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,39).subscribe(
      data=>{
        this.ReadData_Persone()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  ReadData_Persone(){
    this.Procssing=true
    this.Person_Service.GetRecord(this.Token,Number(this.Filter_person)).subscribe(
      data=>{
        this.DataList_Persone = data['result']
        this.DataList_Persone_Excel = data['excelList']
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:Persone_List_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Person_Service.DeletePersone(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")
        this.ReadData_Persone()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "DaroPersonel.xlsx");

  }


  ExpertCalibrationEdit:Persone_List_Interface=Empty_Persone_List_Interface()
  set_ExpertCalibrationEdit(item:Persone_List_Interface)
  {
    this.ExpertCalibrationEdit=item
  }

  OnSet_ExpertCalibrationEdit(item:any)
  {
    this.ReadData_Persone()
    this.ExpertCalibrationEdit=Empty_Persone_List_Interface()
  }


  DeleteExpertCalibration(){
    this.modalRef_DeleteExpertCalibration.hide()
    this.ExpertCalibration_Service.DeleteExpertCalibration(this.Data_Seleted_Delete.id,this.Token).subscribe(
      data=>{
        this.Alertify_Service.SuccessMessage("Deleted successfully.")
        this.ReadData_Persone()
      },error=>{
        localStorage.clear()
        location.reload();
        
      }
    )
  }

  openModalExpertCalibration(template: TemplateRef<any>,Record:Persone_List_Interface) {
    this.Data_Seleted_Delete=Record
    this.modalRef_DeleteExpertCalibration = this.modalService.show(template);
  }

}
